import React, { Component } from 'react'
import { extendObservable } from 'mobx'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { invoicingEntityApi } from '@atheneum/api'

import DocumentTitle from 'react-document-title'

import InvoicingEntityStore from './invoicing-entity.store'

import Actions from './Actions'
import Contact from './Contact'
import Row from '@components/Details/Row'
import Spinner from '@components/spinner'

class InvoicingEntity extends Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string
      }).isRequired,
      url: PropTypes.string
    }).isRequired,
    staticData: PropTypes.object,
    growlStore: PropTypes.object
  }

  constructor(props) {
    super(props)

    extendObservable(this, {
      invoicingEntityStore: new InvoicingEntityStore(
        props.staticData,
        props.growlStore
      )
    })

    const invoicingEntityId = this.props.match.params.id
    this.invoicingEntityStore.getInvoicingEntity(invoicingEntityId)
  }

  componentWillMount() {
    const { projectIdToUpdate } = Object.fromEntries(new URLSearchParams(this.props.location.search))
    const { id: invoiceId } = this.props.match.params

    if (projectIdToUpdate && invoiceId) {
      // If there's projectIdToUpdate, update invoice entity id
      this.updateProjectInvoice(projectIdToUpdate, invoiceId);
    }
  }

  async updateProjectInvoice(projectIdToUpdate, invoiceId) {

    // Should check if address has change, if changed, update it
    // Update project with new invoice entity id
    try {
      await invoicingEntityApi.update({ id: invoiceId }, { projectIdToUpdate })
      // Should we show pop up after update?
    } catch (error) {
      console.error(error);
    }
  }

  renderDetails = () => {
    const { invoicingEntity, timezone } = this.invoicingEntityStore
    return (
      <div>
        <div className='story'>
          <span className='label'>{invoicingEntity.legalName}</span>
        </div>
        <div className='info-wrapper entity'>
          <div className='group'>
            <Row label='GL code' text={invoicingEntity.glCode} />
            <Row label='VAT number' text={invoicingEntity.vatNumber} />
            <Row
              label='Invoicing region'
              text={invoicingEntity.invoicingRegion.name}
            />
            <Row
              label='Legal Entity Address'
              text={invoicingEntity.legalEntityAddress}
            />
          </div>
          {invoicingEntity.address && (
            <div className='group'>
              <Row label='Address' text={invoicingEntity.address.address1} />
              <Row
                label='Secondary address'
                text={invoicingEntity.address.address2}
              />
              <Row label='City' text={invoicingEntity.address.city} />
              <Row
                label='Postal code'
                text={invoicingEntity.address.postalCode}
              />
              <Row
                label='State/Province'
                text={invoicingEntity.address.state}
              />
              <Row
                label='Country'
                text={invoicingEntity.address.country.name}
              />
              <Row label='Timezone' text={timezone} />
            </div>
          )}
          <Row
            label='Comment'
            text={
              invoicingEntity.comment && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: invoicingEntity.comment
                  }}
                />
              )
            }
          />
        </div>
      </div>
    )
  }

  renderContactInfo = () => {
    const { invoicingEntity } = this.invoicingEntityStore

    return (
      <div>
        <div className='story'>
          <span className='label'>Accounting contacts information</span>
          <div className='info-wrapper entity'>
            {invoicingEntity.contacts.map((contact, index) => (
              <Contact contact={contact} key={index} />
            ))}
          </div>
        </div>
      </div>
    )
  }

  render() {
    const matchUrl = this.props.match.url
    const { invoicingEntity, loading } = this.invoicingEntityStore
    if (loading) {
      return <Spinner />
    }

    return (
      <DocumentTitle
        title={`${invoicingEntity.legalName} - invoicing entity | Atheneum Partners`}
      >
        <div className='invoice-wrapper animate-intro'>
          <Actions
            matchUrl={matchUrl}
            invoicingEntityId={this.props.match.params.id}
            invoicingEntity={invoicingEntity}
            invoicingEntityStore={this.invoicingEntityStore}
            parentAccount={invoicingEntity.parentAccount}
          />
          <div className='content entity-info'>
            <div className='col-2'>{this.renderDetails()}</div>
            <div className='col-2 col-2--padding'>
              {invoicingEntity.contacts && invoicingEntity.contacts.length
                ? this.renderContactInfo()
                : null}
            </div>
          </div>
        </div>
      </DocumentTitle>
    )
  }
}

export default withRouter(
  inject('staticData', 'growlStore')(observer(InvoicingEntity))
)
